// Build-time configuration (ENG-280). Values are baked by Vite from
// VITE_* variables: repo variables in deploy-editor.yml for staging, or a
// local .env.local for `npm run dev` (see .env.example). This replaces the
// hardcoded production apiEndpoint fallback that used to live in App.tsx.
export const config = {
  apiEndpoint: import.meta.env.VITE_API_ENDPOINT as string | undefined,
  cognito: {
    // OIDC issuer, e.g. https://cognito-idp.us-east-2.amazonaws.com/<poolId>
    authority: import.meta.env.VITE_COGNITO_AUTHORITY as string | undefined,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined,
    // Login domain without scheme: id.reframer.pro / id.staging.reframer.pro,
    // or the pool's prefix domain (reframer-<env>-<acct>.auth.us-east-2.amazoncognito.com)
    domain: import.meta.env.VITE_COGNITO_DOMAIN as string | undefined,
  },
};

// With no Cognito config baked in (e.g. a bare local dev build), the app
// runs authless: RequireAuth passes through and API calls carry no bearer.
// Against a deployed (JWT-protected) API those calls will 401 — configure
// .env.local with the staging pool to exercise the real flow locally.
export const authEnabled = Boolean(
  config.cognito.authority && config.cognito.clientId
);
